module.exports = __webpack_public_path__ + "cf300920c1b480a9a89028d82c0151ce.png";